import React, { useContext } from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"

import WhatsAppIcon from "./components/WhatsAppIcon"
import SessionWatcher from "./components/security/SessionWatcher"
import ProtectedRoute from "./components/security/ProtectedRoute"
import { AppContext } from "./context/AppContext"

import LoginPage from "./login/LoginPage"
import Register from "./login/Usuario/Register"
import UpdatePasswordPage from "./login/Usuario/UpdatePasswordPage"
import UpdatePassworSystem from "./login/UpdatePasswordPage"

import PrivacyPolicyPage from "./pages/PrivacyPolicyPage"
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage"

import AdminPanel from "./login/Administrador/AdminPanel"
import EnterprisePanel from "./login/Empresa/EnterprisePanel"
import NewInvoice from "./login/Empresa/NuevaFactura/NewInvoice"

import AdminSection from "./login/Administrador/AdminSection"
import Section from "./login/Administrador/Section"
import AdminProduct from "./login/Administrador/AdminProduct"
import Product from "./login/Administrador/Product"
import AdminProforma from "./login/Administrador/AdminProforma"
import Proforma from "./login/Administrador/Proforma"
import ProformaFacturacion from "./login/Administrador/ProformaForm/ProformaFacturacion"
import AdminClient from "./login/Administrador/AdminClient"
import Client from "./login/Administrador/Client"
import AdminVariant from "./login/Administrador/AdminVariant"
import Variant from "./login/Administrador/Variant"
import AdminPromotion from "./login/Administrador/AdminPromotion"
import Promotion from "./login/Administrador/Promotion"
import AdminServices from "./login/Administrador/AdminServices"
import Services from "./login/Administrador/Services"
import AdminClub from "./login/Administrador/AdminClub"
import Club from "./login/Administrador/Club"
import AdminInvoice from "./login/Administrador/AdminInvoice"
import Invoice from "./login/Administrador/Invoice"
import RegisterPurchase from "./login/Administrador/RegisterPurchase"
import AdminAccounts from "./login/Administrador/AdminAccounts"
import AdminMotion from "./login/Administrador/AdminMotion"
import Motion from "./login/Administrador/Motion"
import MotionDetail from "./login/Administrador/MotionForm/MotionDetail"
import AdminBank from "./login/Administrador/AdminBank"
import Bank from "./login/Administrador/Bank"
import Payment from "./login/Administrador/Payment/Payment"
import AdminEcommerce from "./login/Administrador/AdminEcommerce"
import Ecommerce from "./login/Administrador/Ecommerce"

const AppLayout = ({ children }) => {
  const location = useLocation()
  const { logoutUser } = useContext(AppContext)

  const hideWhatsApp =
    location.pathname.startsWith("/admin-panel")

  return (
    <>
      <SessionWatcher logoutUser={logoutUser} />
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <main style={{ flex: 1 }}>{children}</main>
        {!hideWhatsApp && <WhatsAppIcon />}
      </div>
    </>
  )
}

const App = () => {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/actualizar-clave" element={<UpdatePasswordPage />} />
          <Route path="/system/update-password" element={<UpdatePassworSystem />} />

          <Route path="/" element={<LoginPage />} />
          <Route path="/politicas-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/terminos-condiciones" element={<TermsAndConditionsPage />} />

          <Route
            path="/admin-panel/*"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/empresa"
            element={
              <ProtectedRoute>
                <EnterprisePanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/secciones"
            element={
              <ProtectedRoute>
                <AdminSection />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/secciones/nueva"
            element={
              <ProtectedRoute>
                <Section />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/proformas"
            element={
              <ProtectedRoute>
                <AdminProforma />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/proformas/nueva"
            element={
              <ProtectedRoute>
                <Proforma />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/proformas/editar/:id"
            element={
              <ProtectedRoute>
                <Proforma />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/proformas/facturacion/:id"
            element={
              <ProtectedRoute>
                <ProformaFacturacion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/servicios"
            element={
              <ProtectedRoute>
                <AdminServices />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/servicios/nuevo"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/productoclub"
            element={
              <ProtectedRoute>
                <AdminClub />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/productoclub/nuevo"
            element={
              <ProtectedRoute>
                <Club />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/clientes"
            element={
              <ProtectedRoute>
                <AdminClient />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/clientes/nuevo"
            element={
              <ProtectedRoute>
                <Client />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/productos"
            element={
              <ProtectedRoute>
                <AdminProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/productos/nuevo"
            element={
              <ProtectedRoute>
                <Product />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/variantes"
            element={
              <ProtectedRoute>
                <AdminVariant />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/variantes/nueva"
            element={
              <ProtectedRoute>
                <Variant />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/movimientos"
            element={
              <ProtectedRoute>
                <AdminMotion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/movimientos/nuevo"
            element={
              <ProtectedRoute>
                <Motion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/inventario/movimientos/:id"
            element={
              <ProtectedRoute>
                <MotionDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/promociones"
            element={
              <ProtectedRoute>
                <AdminPromotion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/promociones/nueva"
            element={
              <ProtectedRoute>
                <Promotion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/registro/documento"
            element={
              <ProtectedRoute>
                <NewInvoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/reporte/documento"
            element={
              <ProtectedRoute>
                <AdminInvoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/factura/:id"
            element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/compras/registro"
            element={
              <ProtectedRoute>
                <RegisterPurchase />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/admin-cuentas"
            element={
              <ProtectedRoute>
                <AdminAccounts />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/bancos"
            element={
              <ProtectedRoute>
                <AdminBank />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/bancos/nuevo"
            element={
              <ProtectedRoute>
                <Bank />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/pagos/:id"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/ecommerce"
            element={
              <ProtectedRoute>
                <AdminEcommerce />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-panel/ecommerce/:ticket"
            element={
              <ProtectedRoute>
                <Ecommerce />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AppLayout>
    </Router>
  )
}

export default App